<!--支付账户首页-->
<template>
  <div v-loading="loading">
    <!--未开户-->
    <payment-account
      v-if="noAccount"
      ref="paymentAccountOpening"
      :source-data="accountStatusObj"
    ></payment-account>
    <!--已开通结算账户-->
    <div v-else class="has-account">
      <!--显示支付账户注销申请审核拒绝原因-->
      <div v-if="accountStatus === 108" class="review-reason">
        <span>
          <img src="@/assets/img/paymenAccount/warning.png" alt="" />
          审核拒绝原因：
        </span>
        <span>{{ auditReason }}</span>
      </div>
      <div class="module">
        <h5 class="module-title account-info">
          <span>{{ accountStatusObj?.companyName }}</span>
          <!--TODO 该功能暂不开发-->
          <!--<eui-btn type="text">变更企业账户信息</eui-btn>-->
          <!--支付账户可注销-->
          <eui-btn
            v-if="[106, 108].includes(accountStatus)"
            type="text"
            @click="accountOperate(103, logoutCompanyAccount)"
            >注销公司账户</eui-btn
          >
          <!--支付账户注销中-->
          <eui-btn v-if="accountStatus === 110" type="text" style="color: #666"
            >支付账户注销中，请等待审核结果</eui-btn
          >
        </h5>
        <div class="module-descriptions">
          <div class="descriptions-item">
            <span class="label text-number-5">开户申请人：</span>
            <span class="value">
              <span>{{ accountStatusObj?.creatorRealName }}</span>
              <eui-btn type="text" @click="previewFile('AA')"
                >授权书预览</eui-btn
              >
              <eui-btn type="text" @click="previewFile('AC')">证件预览</eui-btn>
            </span>
          </div>
          <div class="descriptions-item">
            <span class="label text-number-6">法定代表人：</span>
            <span class="value">
              <span>{{ accountStatusObj?.legalPerson }}</span>
              <eui-btn type="text" @click="previewFile('LRC')"
                >证件预览</eui-btn
              >
            </span>
          </div>
          <div class="descriptions-item">
            <span class="label text-number-5">开户银行：</span>
            <span class="value">{{ accountStatusObj?.bankAccountName }}</span>
          </div>
          <div class="descriptions-item">
            <span class="label text-number-6">银行账户账号：</span>
            <span class="value">{{ accountStatusObj?.bankAccount }}</span>
          </div>
        </div>
        <div class="module-line"></div>
        <div class="module-list">
          <div
            v-for="item in accountStatusObj?.epayAccountBaseSubStatusVOList"
            :key="item.accountType"
            class="list-item"
          >
            <span class="account-type">{{
              item.accountType | accountTypeDesc
            }}</span>
            <!--产融专户显示显示申请开通按钮-->
            <template v-if="item.accountSubStatus === 100">
              <span v-show="item.accountType !== 0">
                {{ item.accountType | accountIntroduce }}</span
              >
              <eui-btn
                v-show="item.accountType === 2"
                type="weak"
                :disabled="operateButtonDisabled"
                @click="accountSubOperate(item)"
                >申请开通</eui-btn
              >
            </template>
            <!--产融专户显示查看进度按钮-->
            <template
              v-if="item.accountSubStatus === 101 && item.accountType === 2"
            >
              <span>申请已提交，等待审核</span>
              <eui-btn
                type="weak"
                :disabled="operateButtonDisabled"
                @click="accountSubOperate(item)"
              >
                查看进度</eui-btn
              >
            </template>
            <!--产融专户显示开户申请拒绝原因和继续申请按钮-->
            <template
              v-if="item.accountSubStatus === 102 && item.accountType === 2"
            >
              <span>拒绝原因：{{ item?.accountSubAuditReason }}</span>
              <eui-btn
                type="weak"
                :disabled="operateButtonDisabled"
                @click="accountSubOperate(item)"
              >
                继续申请</eui-btn
              >
            </template>
            <!--申请注销 和 注销申请被拒绝-->
            <template v-if="item.accountSubStatus === 103">
              <!--易支付和产融专户显示账户账号-->
              <span>{{ item?.accountSubBankAccount }}</span>
              <!-- 易支付账户不显示注销按钮-->
              <eui-btn
                v-show="item.accountType !== 0"
                type="weak"
                :disabled="operateButtonDisabled"
                @click="accountSubOperate(item)"
                >注销{{ item.accountType | accountTypeDesc }}</eui-btn
              >
            </template>
            <!--注销申请审核中-->
            <template
              v-if="item.accountSubStatus === 104 && item.accountType !== 0"
            >
              <span>注销申请已提交，等待审核</span>
            </template>
          </div>
        </div>
      </div>
      <div class="module">
        <h5 class="module-title">操作用户</h5>
        <div class="table-button">
          <eui-btn
            type="primary"
            :disabled="operateButtonDisabled"
            @click="addUser"
            >新增用户</eui-btn
          >
          <eui-btn
            v-show="accountStatusObj?.opMode === 2"
            type="weak"
            :disabled="operateButtonDisabled"
            @click="logoutUser"
            >用户注销</eui-btn
          >
          <eui-btn
            type="weak"
            :disabled="operateButtonDisabled"
            @click="addUkey"
            >Ukey补办</eui-btn
          >
        </div>
        <TableList
          :table-data="userTableData"
          :table-label="userTableLabel"
          row-key="userId"
        >
          <template #role="slot">
            <span>{{ slot.scope.row.role | roleDesc }}</span>
          </template>
          <template #status="slot">
            <span>{{ slot.scope.row.status | userStatusDesc }}</span>
          </template>
          <template #operate="slot">
            <eui-btn
              v-show="slot.scope.row.status === 100"
              type="text"
              :disabled="operateButtonDisabled"
              @click="updateUser(slot.scope.row)"
              >修改</eui-btn
            >
          </template>
        </TableList>
      </div>
      <div class="module">
        <h5 class="module-title">操作记录</h5>
        <el-form :inline="true" :model="searchForm" class="module-search-form">
          <el-form-item label="用户姓名">
            <el-input
              v-model="searchForm.realName"
              placeholder="请输入用户姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <eui-btn type="weak" @click="handleFilter">查询</eui-btn>
          </el-form-item>
        </el-form>
        <TableList
          :table-data="recordTableData"
          :table-label="recordTableLabel"
        >
          <template #applyType="slot">
            <span>{{ slot.scope.row.applyType | applyTypeDesc }}</span>
          </template>
          <template #status="slot">
            <span
              :class="{ theme: slot.scope.row.status === 102 }"
              @click="viewReason(slot.scope.row)"
              >{{ slot.scope.row.status | statusDesc }}</span
            >
          </template>
          <template #operate="slot">
            <el-button
              v-show="[1, 3].includes(slot.scope.row.applyType)"
              type="text"
              @click="viewTrackingNumber(slot.scope.row)"
              >查看</el-button
            >
          </template>
        </TableList>
        <el-pagination
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="searchForm.pageNum"
          :page-size="searchForm.pageSize"
          :total="searchForm.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <div class="module">
        <h5 class="module-title">企业信息变更记录</h5>
        <TableList
                :table-data="changeTableData"
                :table-label="changeTableLabel"
        >
          <template #authAttachName="slot">

            <eui-btn type="text" @click="downLoadChangeFile(slot.scope.row.authAttachPath,slot.scope.row.authAttachName)">{{slot.scope.row.authAttachName}}</eui-btn>
          </template>
          <template #companyName="slot">
            <eui-tooltip-over
                    :content="slot.scope.row.companyName"
                    :tooltipStyle="{ width: '130px', fontsize: '12px' }"
                    :line="2"
            >
              <div>{{ slot.scope.row.companyName }}</div>
            </eui-tooltip-over>
          </template>
          <template #regCity="slot">
            <eui-tooltip-over
                    :content="slot.scope.row.regCity"
                    :tooltipStyle="{ width: '100px', fontsize: '12px' }"
                    :line="2"
            >
              <div>{{ slot.scope.row.regCity }}</div>
            </eui-tooltip-over>
          </template>
          <template #accountStatus="slot">
            <eui-tooltip
                    v-if="Number(slot.scope.row.accountStatus) === 141 && slot.scope.row.auditReason"
                    class="item"
                    effect="dark"
                    :content="slot.scope.row.auditReason"
                    placement="bottom">
              <eui-btn type="text" color="error">审核拒绝</eui-btn>
            </eui-tooltip>
            <eui-btn type="text" color="error"  v-if="Number(slot.scope.row.accountStatus) === 141 && !slot.scope.row.auditReason">审核拒绝</eui-btn>

            <eui-btn type="text" v-if="Number(slot.scope.row.accountStatus) === 112 " >审核中</eui-btn>
            <eui-btn type="text" v-if="Number(slot.scope.row.accountStatus) === 142 " >审核通过</eui-btn>
          </template>
          <template #operate="slot">
              <eui-btn type="text" v-if="Number(slot.scope.row.canModify) === 1" @click="handleEdit(slot.scope.row.id)">
                  修改
              </eui-btn>
            <eui-btn type="text" @click="viewDetail(slot.scope.row.id)">查看</eui-btn>
          </template>
        </TableList>
        <el-pagination
                :page-sizes="[10, 20, 30]"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="changeData.pageNum"
                :page-size="changeData.pageSize"
                :total="changeData.pageTotal"
                prev-text="上一页"
                next-text="下一页"
                @size-change="changeSize"
                @current-change="changeCurrent"
        ></el-pagination>
      </div>
    </div>
      <el-image ref="cFImg" :src="bigImageUrl" :preview-src-list="previewSrcList"
                style="width: 0; height: 0"></el-image>
    <common-dialog
      ref="commonDialog"
      :progress-data="progressData"
    ></common-dialog>
    <!--审核拒绝原因-->
    <approve-refuse-dialog ref="approveRefuseDialog"></approve-refuse-dialog>
    <!--预览-->
    <viewer-image
      ref="viewer"
      :preview-src-list="[dialogPicUrl]"
    ></viewer-image>
    <!--企业信息变更记录弹框 -->
    <payment-account-opening-review
            v-if="visible"
            :visible.sync="visible"
            :id="changeId"
            :canModify="canModify"
    />
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import TableList from '../../components/common/e-table-list';
import PaymentAccount from './paymentAccount';
import CommonDialog from './paymentAccountUser/commonDialog';
import ViewerImage from './components/viewerImage';
import ApproveRefuseDialog from './paymentAccountUser/approveRefuseDialog';
import { logoutCompanyAccount } from './constant';
import paymentAccountOpeningReview from './common/paymentAccountOpeningReview';

export default {
  name: 'Index',
  components: {
    PaymentAccount,
    TableList,
    CommonDialog,
    ViewerImage,
    ApproveRefuseDialog,
    paymentAccountOpeningReview
  },
  filters: {
    accountTypeDesc(type) {
      const accountList = [
        { label: '易支付账户', value: 0 },
        { label: '易权通清算户', value: 1 },
        { label: '产融还款专户', value: 2 },
      ];
      return accountList.find((item) => item.value === type)?.label;
    },
    statusDesc(status) {
      const statusList = [
        { label: '审核通过', value: 100 },
        { label: '审核中', value: 101 },
        { label: '审核拒绝', value: 102 },
        { label: '完成', value: 103 },
      ];
      return statusList.find((item) => item.value === status)?.label;
    },
    applyTypeDesc(type) {
      const applyTypeList = [
        { label: '新增用户', value: 1 },
        { label: '修改用户', value: 2 },
        { label: '补办ukey', value: 3 },
        { label: '注销用户', value: 4 },
      ];
      return applyTypeList.find((item) => item.value === type)?.label;
    },
    roleDesc(role) {
      const roleList = [
        { label: '经办', value: 'F002' },
        { label: '审核', value: 'F003' },
        { label: '查询', value: 'F004' },
        { label: '经办、审核', value: 'F002,F003' },
        { label: '经办、查询', value: 'F002,F004' },
        { label: '审核、查询', value: 'F003,F004' },
        { label: '经办、审核、查询', value: 'F002,F003,F004' },
      ];
      return roleList.find((item) => item.value === role)?.label;
    },
    userStatusDesc(status) {
      const statusList = [
        { label: '生效', value: 100 },
        { label: '创建中', value: 101 },
        { label: '注销中', value: 102 },
        { label: '补办ukey中', value: 103 },
        { label: '修改中', value: 104 },
      ];
      return statusList.find((item) => item.value === status)?.label;
    },
    accountIntroduce(type) {
      if (type === 1) {
        return '助力易派客平台关联方资金融通，集随时变现、信用结算、灵活拆分、多级流转、便捷高效、安全合规六大核心优势';
      }
      return '为促进产业数字金融与产业互联网融合发展，实现金融服务全面融入产业生态，为实体经济提供更高质量的金融服务';
    },
  },
  data() {
    return {
      bigImageUrl: '',
      previewSrcList: [],
      canModify:0,
      changeId:'',
      visible:false,
      loading: false,
      auditReason: '',
      accountStatus: null,
      accountStatusObj: {},
      noAccount: false,
      hasAccountStatus: [106, 108, 110], // 已开通支付账户
      userTableData: [],
      userTableLabel: [
        {
          label: '姓名',
          param: 'realName',
          align: 'center',
        },
        {
          label: '支付平台账号',
          param: 'paycenterLoginAccount',
          align: 'center',
          width: '200',
        },
        { label: '电话号码', param: 'mobile', align: 'center', tooltip: true },
        { label: '邮箱', param: 'email', align: 'center', tooltip: true },
        {
          label: '用户权限',
          param: 'role',
          align: 'center',
          slot: 'role',
          tooltip: true,
        },
        {
          label: '状态',
          param: 'status',
          align: 'center',
          slot: 'status',
          tooltip: true,
        },
        { label: '操作', slot: 'operate', align: 'center', tooltip: true },
      ],
      recordTableData: [],
      recordTableLabel: [
        { label: '用户名称', param: 'realName', align: 'center', width: '200' },
        {
          label: '提交时间',
          param: 'createTime',
          width: '290',
          align: 'center',
        },
        {
          label: '操作类型',
          param: 'applyType',
          align: 'center',
          slot: 'applyType',
        },
        { label: '完成时间', param: 'finishTime', align: 'center' },
        { label: '操作结果', param: 'status', align: 'center', slot: 'status' },
        { label: '快递单号', slot: 'operate', align: 'center' },
      ],
      searchForm: {
        realName: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      changeData:{
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      dialogPicUrl: '',
      showQueryRole: false,
      logoutCompanyAccount,
      progressData: {},
      changeTableData:[],
      changeTableLabel:[
        {label: '公司名称', param: 'companyName', align: 'center',slot:'companyName',width:'150'},
        {label: '公司注册地', param: 'regCity', align: 'center',slot:'regCity',width:'120'},
        {label: '申请人', param: 'creatorRealName', align: 'center',},
        {label: '易派客用户名', param: 'creator', align: 'center',},
        {label: '管理员支付授权书', param: 'authAttachName', align: 'center', slot: 'authAttachName'},
        {label: '企业信息变更时间', param: 'createTime', align: 'center',width:'140'},
        {
          label: '完成时间', param: 'auditTime', align: 'center', width: '140', render: (row) => {
            return Number(row.accountStatus) === 142 ? row.auditTime : '';
          },
        },
        {label: '状态', param: 'accountStatus', align: 'center',slot:'accountStatus',width:'80'},
        {label: '操作', param: '', align: 'center',slot:'operate'},
       ],
    };
  },

  computed: {
    operateButtonDisabled() {
      // 当支付账户处于注销中状态时，不能操作所有功能
      return this.accountStatus === 110;
    },
  },
  created() {},
  mounted() {
    // 查询结算账户状态
    this.getEpaySettleAccountStatus();
  },
  methods: {
    changeSize(val) {
      this.changeData.pageSize = val;
      this.queryModifyPage();
    },
    changeCurrent(val) {
      this.changeData.pageNum = val;
      this.queryModifyPage();
    },
    handleEdit(id) {
      this.canModify = 1;
      this.changeId = id;
      this.visible = true;
    },
    viewDetail(id){
      this.visible = true;
      this.changeId = id;
      this.canModify = 0;
     },
    downLoadChangeFile(authAttachPath,fileName){
      Api.getPayCenterFile({ filePath: authAttachPath }).then((res) => {
        if (res.success) {
            this.downloadFile(res.data,fileName);
        }
      });

    },
    downloadFile(url,fileName) {
      let features = 'height=470,width=820,top=180,left=520,toolbar=no,scrollbars=yes,menubar=no,location=no,status=no';
      const viewImageUrl = this.$router.resolve({path: '/viewImage'}).href;
      const fileType = fileName.substr(fileName?.lastIndexOf('.') + 1);
      if (fileType?.toLowerCase() !== 'pdf') {
        // 预览图片
        this.bigImageUrl = url;
        this.previewSrcList = [url];
        this.$nextTick(() => {
          this.$refs.cFImg.showViewer = true;
        });
      } else {
        // 预览pdf
        window.open(url, '_blank', features);
      }
    },
    // 查询结算账户状态
    async getEpaySettleAccountStatus() {
      this.loading = true;
      const res = await Api.getEpaySettleAccountStatus().finally(() => {
        this.loading = false;
      });
      if (res.code === '200') {
        this.noAccount = !this.hasAccountStatus.includes(
          res.data?.accountStatus
        );
        // this.noAccount = !this.hasAccountStatus.includes(100);
        this.accountStatus = res.data.accountStatus;
        this.auditReason = res.data.auditReason;
        this.accountStatusObj = this.noAccount
          ? res.data
          : res.data?.epayAccountBaseInfoVO;
        if (!this.noAccount) {
          this.queryRecordList();
          this.queryAccountUserList();
          this.queryModifyPage();//企业信息变更-列表
          // 企业拥有易权通或者产融时，显示查询权限
          this.showQueryRole =
            this.accountStatusObj?.epayAccountBaseSubStatusVOList[1]
              .accountSubStatus === 103 ||
            this.accountStatusObj?.epayAccountBaseSubStatusVOList[2]
              .accountSubStatus === 103;
        }
      }
    },
    previewFile(type) {
      const fileObj = this.accountStatusObj?.epayAccountBaseAttachVOList?.find(
        (item) => item.attachType === type
      );
      if (fileObj?.attachPath) {
        Api.getPayCenterFile({ filePath: fileObj.attachPath }).then((res) => {
          if (res.code === '200') {
            this.dialogPicUrl = res.data;
            this.$refs.viewer.show();
          }
        });
      } else {
        this.$message.info('暂无可预览文件');
      }
    },
    accountSubOperate(params) {
      this.progressData = params;
      this.accountOperate(params.accountSubStatus, params.accountType);
    },
    accountOperate(accountStatus, accountType, trackingNumber) {
      // 账户类型accountType 默认 0：结算账户，1：清算账户, 2 : 产融专户
      const params = {
        accountStatus,
        accountType,
        trackingNumber,
        dialogTitle: '易权通专户开通申请',
        dialogWidth: '580px',
        showBtn: true,
        showCloseBtn: false,
        confirmBtnText: '',
      };
      switch (accountStatus) {
        case 99:
          // 单人模式，提示修改用户权限
          if (this.accountStatusObj?.opMode === 1) {
            params.dialogTitle = '提示';
            params.confirmBtnText = '修改已有用户权限';
            this.$refs.commonDialog.initData(params);
          }
          // 多人模式，打开新增用户页面
          if (this.accountStatusObj?.opMode === 2) {
            this.$router.push({
              name: 'PaymentAccountAddUser',
              query: { showQueryRole: this.showQueryRole },
            });
          }
          break;
        case 100:
          // 打开申请开户页面
          // 易权通账户
          if (accountType === 1) {
            params.confirmBtnText = '提交';
            this.$refs.commonDialog.initData(params);
          }
          // 产融还款账户
          if (accountType === 2) {
            this.$router.push({
              name: 'financialAccountOpening',
              query: {
                pageFrom: 'paymentAccount',
                reSubmitBtn: false,
              },
            });
          }
          break;
        case 101:
          // 查看进度
          params.dialogTitle = '查看进度';
          params.showBtn = false;
          params.showCloseBtn = true;
          this.$refs.commonDialog.initData(params);
          break;
        case 102:
          // 打开继续申请开户页面
          // 易权通账户
          if (accountType === 1) {
            params.confirmBtnText = '提交';
            this.$refs.commonDialog.initData(params);
          }
          // 产融还款账户
          if (accountType === 2) {
            this.$router.push({
              name: 'financialAccountOpening',
              query: {
                pageFrom: 'paymentAccount',
                applyId: this.progressData?.applyId.toString(),
                reSubmitBtn: true,
              },
            });
          }
          break;
        case 103:
          if (
            accountType === 0 &&
            this.accountStatusObj?.epayAccountBaseSubStatusVOList[2]
              .accountSubStatus === 103
          ) {
            // 注销易支付账户
            // 易支付账户注销时，需要验证是否已开通产融专户。若已开通产融专户提示用户“您已开通产融还款专户，请先注销产融还款专户。
            params.dialogTitle = '提示';
            params.dialogWidth = '420px';
            params.showBtn = false;
            params.showCloseBtn = true;
            this.$refs.commonDialog.initData(params);
          } else if (accountType === logoutCompanyAccount) {
            // 注销企业账户
            params.dialogTitle = '提示';
            params.dialogWidth = '420px';
            params.confirmBtnText = '继续注销';
            this.$refs.commonDialog.initData(params);
          } else {
            Api.checkCancelEpayAccountSub({
              accountType,
            }).then((res) => {
              if (res.code === '200') {
                if (res.data.status) {
                  // 注销产融专户
                  if (accountType === 2) {
                    if (!res.data?.msg) {
                      // 可注销
                      this.logoutSubAccount(accountType);
                    } else {
                      // 确认注销产融专户
                      params.dialogTitle = '提示';
                      params.dialogWidth = '420px';
                      params.confirmBtnText = '继续注销';
                      params.tipsText = res.data.msg;
                      this.$refs.commonDialog.initData(params);
                    }
                  } else {
                    // 注销易权通账户
                    this.logoutSubAccount(accountType);
                  }
                } else {
                  // 不可注销
                  params.dialogTitle = '提示';
                  params.dialogWidth = '420px';
                  params.showBtn = false;
                  params.showCloseBtn = true;
                  params.tipsText = res.data.msg;
                  this.$refs.commonDialog.initData(params);
                }
              }
            });
          }
          break;
        default:
          // 查看快递单号
          params.dialogTitle = '查看快递单号';
          params.dialogWidth = '420px';
          params.showBtn = false;
          params.showCloseBtn = true;
          this.$refs.commonDialog.initData(params);
          break;
      }
    },
    // 新增用户
    addUser() {
      this.accountOperate(99);
    },
    // 修改用户
    updateUser(row) {
      this.$router.push({
        name: 'PaymentAccountUpdateUser',
        query: {
          changeMultipleMode: false,
          roleDisabled: true, // 修改用户时，单人模式和多人模式用户权限都不可编辑；
          userId: row.userId,
          showQueryRole: this.showQueryRole,
        },
      });
    },
    // 注销用户
    logoutUser() {
      this.$router.push({ name: 'PaymentAccountLogoutUser' });
    },
    // 注销专户
    logoutSubAccount(accountType) {
      this.$router.push({
        name: 'PaymentAccountLogoutAccountSub',
        query: { accountType },
      });
    },
    // Ukey补办
    addUkey() {
      this.$router.push({ name: 'PaymentAccountAddUkey' });
    },
    // 查看快递单号
    viewTrackingNumber(row) {
      this.accountOperate(null, null, row.trackingNumber);
    },
    // 操作记录，操作结果为审核拒绝时，查看拒绝原因
    viewReason(row) {
      if (row.status === 102) {
        this.$refs.approveRefuseDialog.initData(row);
      }
    },
    handleFilter() {
      this.searchForm.pageNum = 1;
      this.queryRecordList();
    },
    handleSizeChange(val) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = val;
      this.queryRecordList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNum = val;
      this.queryRecordList();
    },
    // 查询操作记录
    async queryRecordList() {
      const { realName, pageSize, pageNum } = this.searchForm;
      const res = await Api.queryAccountUserApplyOperatePage({
        realName,
        pageSize,
        pageNum,
      });
      if (res.code === '200') {
        this.recordTableData = res.data.records;
        this.searchForm.pageTotal = res.data.total;
      }
    },
    // 企业信息变更-列表
    async queryModifyPage(){
      const res = await Api.queryModifyPage(this.changeData)
      if(res.success){
          this.changeTableData = res.data.records || [];
          this.changeData.pageTotal = res.data.total || 0;
      }
    },
    async queryAccountUserList() {
      const res = await Api.queryAccountUserList();
      if (res.code === '200') {
        this.userTableData = res.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.has-account {
  .review-reason {
    width: 100%;
    display: flex;
    padding: 15px 10px;
    background: #fdf0f1;
    span {
      color: #333;
      font-family: Source Han Sans CN;
      font-size: 14px;
      font-style: normal;
      font-weight: 350;
    }
    span:first-child {
      display: flex;
      img {
        opacity: 1;
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }
    }
    span:last-child {
      flex: 1;
    }
  }
  .module {
    margin: 20px 0;
    padding: 20px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 0px 10px 0px #0000001a;
    background: #ffffff;
    .module-title {
      color: #333;
      font-family: Source Han Sans CN;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px; /* 100% */
      margin-bottom: 20px;
      span {
        margin-right: 10px;
      }
    }
    .account-info {
      margin-bottom: 0;
    }
    .module-descriptions {
      display: flex;
      flex-wrap: wrap;
      .descriptions-item:nth-child(odd) {
        width: 45%;
      }
      .descriptions-item:nth-child(even) {
        width: 55%;
      }
      .descriptions-item {
        //width: 50%;
        display: flex;
        margin-top: 20px;
        color: #333;
        font-family: Source Han Sans CN;
        font-size: 14px;
        font-style: normal;
        font-weight: 350;
        line-height: 14px; /* 100% */
        .label {
          display: inline-block;
          white-space: nowrap;
          text-align: right;
        }
        .value {
          flex: 1;
          span {
            margin-right: 10px;
          }
          ::v-deep .btn_eui {
            height: auto !important;
            line-height: 0 !important;
          }
        }
        .text-number-5 {
          width: 84px;
        }
        .text-number-6 {
          width: 98px;
        }
      }
    }
    .module-line {
      border-top: 1px dotted #c5c5c5;
      margin-top: 20px;
    }
    .module-list {
      display: flex;
      margin-top: 20px;
      .list-item {
        width: 33.3%;
        min-height: 126px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #dcdcdc;
        padding: 20px;
        font-family: Source Han Sans CN;
        .account-type {
          color: #333;
          font-size: 18px;
          font-weight: 500;
          line-height: 18px; /* 100% */
        }
        span:nth-child(2) {
          padding: 10px 0 20px;
          color: #666;
          font-size: 14px;
          font-weight: 350;
          line-height: 14px; /* 100% */
        }
        ::v-deep .btn_eui {
          height: 24px;
          line-height: 24px;
        }
      }
      .list-item:nth-child(2) {
        margin: 0 20px;
      }
    }
    .table-button {
      margin-bottom: 10px;
    }
    .module-search-form {
      ::v-deep .el-form-item--small.el-form-item {
        margin-bottom: 10px;
      }

      ::v-deep .el-input--small .el-input__inner {
        height: 30px;
        line-height: 30px;
      }
      ::v-deep .el-form-item--small .el-form-item__content {
        line-height: 30px;
      }
    }
    ::v-deep .el-form--inline .el-form-item {
      margin-right: 30px;
    }
    ::v-deep .el-pagination {
      text-align: right;
      margin-top: 20px;
    }
  }
  ::v-deep thead .el-table-column--selection .cell {
    display: none;
  }
}
.theme {
  color: $main-col;
  cursor: pointer;
}
</style>
